import { gsap, Power4 } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { CSSPlugin } from 'gsap/CSSPlugin';

gsap.registerPlugin(ScrollTrigger, CSSPlugin);

gsap.config({
    nullTargetWarn: false,
});

function revealElement(item) {
    item.style.visibility = 'visible';
    item.setAttribute('data-animating', '');

    gsap.set(item, {
        transformOrigin: 'center center',
    });
}

function revealNestedButtons(container) {
    container.querySelectorAll('.btn').forEach((btn) => {
        btn.style.visibility = 'visible';
    });
}

function prepareAnimationGroup(group) {
    const remove = [];

    group.forEach((item, index) => {
        if (item.parentNode.closest('[data-animating]')) {
            if (item.classList.contains('btn')) {
                revealElement(item);
            }

            remove.push(index);
            return;
        }

        revealElement(item);

        if (item.matches('.content-grid .item')) {
            revealNestedButtons(item);
        }
    });

    if (remove.length > 0) {
        remove.reverse().forEach((index) => {
            group.splice(index, 1);
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const targets = [
        '.animate-site .main-content > div:not(.combo)',
        '.animate-site .main-content > div.combo > div',
    ];

    const slideInElements = document.querySelectorAll(targets.join(', '));

    // Arrange from outer to inner in the DOM to avoid animating things within already animating things
    const slideUpTargets = [
        // Blocks
        '.content-grid .item',

        // Basics
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'p:not(.btns)',
        'ul',
        'blockquote',
        'table',

        // Formidable
        '.frm_submit',
        '.frm_forms .form-field',
    ].join(',');

    const slideFromLeft = [
        '.accent-image.align-left .accent',
    ].join(',');

    const slideFromRight = [
        '.accent-image.align-right .accent',
    ].join(',');

    const slideFromLeftLong = [
        '.blank',
    ].join(',');

    const slideFromRightLong = [
        '.blank',
    ].join(',');

    const drawIn = [
        '.blank path',
    ].join(',');

    setTimeout(() => {
        slideInElements.forEach((slideInElement) => {
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: slideInElement,
                    start: 'top 75%',
                    // markers: true,
                },
            });

            const slideUpElements = Array.from(slideInElement.querySelectorAll(slideUpTargets));
            const fromLeft = Array.from(slideInElement.querySelectorAll(slideFromLeft));
            const fromRight = Array.from(slideInElement.querySelectorAll(slideFromRight));
            const fromLeftLong = Array.from(slideInElement.querySelectorAll(slideFromLeftLong));
            const fromRightLong = Array.from(slideInElement.querySelectorAll(slideFromRightLong));
            const fromDrawIn = Array.from(slideInElement.querySelectorAll(drawIn));

            [slideUpElements, fromLeft, fromRight, fromLeftLong, fromRightLong, fromDrawIn].forEach((group) => {
                prepareAnimationGroup(group);
            });

            const buttonElements = Array.from(slideInElement.querySelectorAll('.btns, .btn:not(.btns .btn):not(.content-grid .btn)'));
            buttonElements.forEach((item) => {
                revealElement(item);
                revealNestedButtons(item);
            });

            tl.addLabel('start');

            // Pre-set the start states explicitly and tween TO explicit end values.
            // Using from() here is unsafe: for timelines that sit paused until
            // scrolled to, ScrollTrigger's revert/refresh cycle can corrupt the
            // recorded end values (e.g. re-reading them after the element's own
            // hidden start state was applied), leaving buttons stuck invisible.
            gsap.set(slideUpElements, { y: 25, opacity: 0 });
            gsap.set(buttonElements, { y: 25, autoAlpha: 0 });
            gsap.set(fromLeft, { x: -25, opacity: 0 });
            gsap.set(fromRight, { x: 25, opacity: 0 });
            gsap.set(fromLeftLong, { x: -2000, opacity: 0 });
            gsap.set(fromRightLong, { x: 2000, opacity: 0 });

            tl.to(slideUpElements, { y: 0, opacity: 1, duration: .5, stagger: 0.125, ease: Power4.easeOut }, 'start');
            tl.to(buttonElements, { y: 0, autoAlpha: 1, duration: .5, stagger: 0.125, ease: Power4.easeOut }, 'start');
            tl.to(fromLeft, { x: 0, opacity: 1, duration: .5, stagger: 0.125, ease: Power4.easeOut }, 'start');
            tl.to(fromRight, { x: 0, opacity: 1, duration: .5, stagger: 0.125, ease: Power4.easeOut }, 'start');
            tl.to(fromLeftLong, { x: 0, opacity: 1, duration: .5, stagger: 0.125, ease: Power4.easeOut }, 'start');
            tl.to(fromRightLong, { x: 0, opacity: 1, duration: .5, stagger: 0.125, ease: Power4.easeOut }, 'start');

            // If the block is already on screen, reveal it immediately instead of
            // waiting for a scroll event that may never cross the trigger start.
            const rect = slideInElement.getBoundingClientRect();
            if (rect.top < window.innerHeight && rect.bottom > 0) {
                tl.play();
            }
        });

        // Layout may have shifted since these triggers were created (fonts,
        // sliders, images loading in), so recalculate start positions.
        ScrollTrigger.refresh();

        // If load already fired before the triggers existed, ScrollTrigger's own
        // load-time refresh never covered them, so refresh once more.
        if (document.readyState === 'complete') {
            ScrollTrigger.refresh();
        } else {
            window.addEventListener('load', () => ScrollTrigger.refresh(), { once: true });
        }
    }, 400);
});
